import { connect } from 'react-redux';
import _flatMap from 'lodash/flatMap';
import _hasIn from 'lodash/hasIn';
import _isEmpty from 'lodash/isEmpty';
import { selectLocaleData } from 'selectors/locale-data';
import AvailabilitySummary from './AvailabilitySummary';

const mapStateToProps = (state, ownProps) => {
  const { offsetDaysOfWeek } = selectLocaleData(state);
  const { recurrence = {}, ...restOwnProps } = ownProps;

  const repeatDays = offsetDaysOfWeek.filter(({ en }) => _hasIn(recurrence, en));
  const startTimes = _flatMap(repeatDays, ({ en }) => recurrence[en].map(({ startTime }) => startTime));
  const endTimes = _flatMap(repeatDays, ({ en }) => recurrence[en].map(({ endTime }) => endTime));

  return {
    isSameTime:
      startTimes.every(element => element === startTimes[0]) && endTimes.every(element => element === endTimes[0]),
    isNoRecurring: _isEmpty(recurrence),
    repeatDays,
    startTime: startTimes && startTimes[0],
    endTime: endTimes && endTimes[0],
    ...restOwnProps,
  };
};

export default connect(mapStateToProps)(AvailabilitySummary);
